import { ChartData, durationConfig, PeriodType } from "@/app/interface/global";
import moment from "moment";
import { GraphOhlc } from "@/app/global/use-us-stocks";

export const handlePriceGraphParams = (symbol: string, duration: PeriodType) => {
    const config = durationConfig[duration];

    if (!config) {
        console.log(`Invalid duration: ${duration}`);
        return;
    }

    const toDate = moment().format("YYYY-MM-DD");
    let fromDate;

    if (config && "all" in config) {
        fromDate = moment("2000-01-01").format("YYYY-MM-DD");
    } else {
        const fromMoment = moment();

        if (config && "days" in config) {
            fromMoment.subtract(config.days, "days");
        }

        if (config && "months" in config) {
            fromMoment.subtract(config.months, "months");
        }

        if (config && "years" in config) {
            fromMoment.subtract(config.years, "years");
        }

        fromDate = fromMoment.format("YYYY-MM-DD");
    }

    return {
        symbol: symbol,
        from: fromDate,
        to: toDate,
        resolution: config.resolution,
    };
};

export const getPriceGraphData = (data: GraphOhlc[]): ChartData[] | undefined => {
    const result: ChartData[] = [];

    if (data?.length > 0) {
        data.forEach((d: GraphOhlc) => {
            result.push({ x: +d?.t * 1000, y: d?.c });
        });
    }

    return result?.length ? [...result] : undefined;
};
